{
    "Quantity": "Quantity",
    "Item": "Item",
    "CMEnvironment": "CMEs",
    "TelephonyServer": "Telephony Server",
    "Partitions": "Partitions",
    "Devices": "Devices",
    "Agents": "Agents",
    "ReportingUsers": "Reporting Users",
    "NonReportingUsers": "Non-Reporting Users",
    "NAME": "Estate",
    "Estate_ButtonHelpLabel": "Help?",
    "Estate_ButtonSubmitLabel": "OK",
    "Estate_ButtonCancelLabel": "Cancel",
    "Estate_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "Estate_PromptConfirm": "Yes",
    "Estate_PromptCancel": "Cancel"
}